<template>
  <div>
    <el-dialog
      width="30%"
      title="小说废弃信息"
      :visible.sync="innerVisible"
      append-to-body
    >
      <div>
        <div class="novel_box">
          <div>旧小说：{{ old_novel.name }}</div>
          <div style="margin-left:30px">创建时间：{{ old_novel.created_at }}</div>
        </div>
        <div class="novel_box">
          <div>新小说：{{ new_novel.name }}</div>
          <div style="margin-left:30px">创建时间：{{ new_novel.created_at }}</div>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import { novelAbandoned } from '@/api/report/novalList.js'
export default {
  data() {
    return {
      innerVisible: false,
      new_novel: {},
      old_novel: {}
    }
  },
  methods: {
    async open(id) {
      this.innerVisible = true
      const data = await novelAbandoned({ novel_id: id })
      this.new_novel = data.data.new_novel
      this.old_novel = data.data.old_novel
    }
  }
}
</script>

<style scoped>
.novel_box{
 display: flex;
 align-items: center;
 margin-bottom: 20px;
}
</style>
